import _ from 'lodash'
import columnDetail from '../columnDetail'
export default {
  id: 'image4',
  name: 'image4',
  type: 'standard',
  moduleName: 'editor_module_image4',
  dataSet: {
    mods: 'flexible',
    column: [
      {
        type: 'image',
        flex: 1,
        value: null,
        detail: {
          options: ['link', 'border', 'background', 'upload', 'radius'],
          link: _.cloneDeep(columnDetail.link),
          border: _.cloneDeep(columnDetail.border),
          background: _.cloneDeep(columnDetail.background),
          upload: _.cloneDeep(columnDetail.upload),
          radius: _.cloneDeep(columnDetail.radius)
        }
      },
      {
        type: 'image',
        flex: 1,
        value: null,
        detail: {
          options: ['link', 'border', 'background', 'upload', 'radius'],
          link: _.cloneDeep(columnDetail.link),
          border: _.cloneDeep(columnDetail.border),
          background: _.cloneDeep(columnDetail.background),
          upload: _.cloneDeep(columnDetail.upload),
          radius: _.cloneDeep(columnDetail.radius)
        }
      },
      {
        type: 'image',
        flex: 1,
        value: null,
        detail: {
          options: ['link', 'border', 'background', 'upload', 'radius'],
          link: _.cloneDeep(columnDetail.link),
          border: _.cloneDeep(columnDetail.border),
          background: _.cloneDeep(columnDetail.background),
          upload: _.cloneDeep(columnDetail.upload),
          radius: _.cloneDeep(columnDetail.radius)
        }
      },
      {
        type: 'image',
        flex: 1,
        value: null,
        detail: {
          options: ['link', 'border', 'background', 'upload', 'radius'],
          link: _.cloneDeep(columnDetail.link),
          border: _.cloneDeep(columnDetail.border),
          background: _.cloneDeep(columnDetail.background),
          upload: _.cloneDeep(columnDetail.upload),
          radius: _.cloneDeep(columnDetail.radius)
        }
      }
    ]
  },
  setting: {
    layout: {
      options: [
        'link',
        'fullsize',
        'columns',
        'background',
        'border',
        'text',
        'padding'
      ]
    },
    action: null,
    detail: {}
  }
}
